import { Navigate, Route, Routes } from "react-router";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminFeedbackPage } from "@/features/admin/feedback";
import { AdminUsersPage } from "@/features/admin/users";
import { ChatPage } from "@/features/chat";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";
import { SelectBrandPage } from "@/features/select-brand";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/select-brand" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/select-brand" element={<SelectBrandPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/chat/:conversationId" element={<ChatPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
        <Route path="/admin/feedback" element={<AdminFeedbackPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
